import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface PersonalNumberErrors {
  invalidBirthday?: true;
  invalidCheckDigit?: true;
  invalidFormat?: true;
  invalidLength?: true;
  isEmpty?: true;
}

export const personalNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control) {
    return null;
  }

  let input: string = (control.value ?? '').toString().trim();

  if (!input) {
    return { isEmpty: true };
  }

  if (input.indexOf('-') === -1) {
    if (input.length === 10) {
      input = input.slice(0, 6) + '-' + input.slice(6);
    } else if (input.length === 12) {
      input = input.slice(0, 8) + '-' + input.slice(8);
    }
  }

  const match = input.match(/^(\d{2})?(\d{2})(\d{2})(\d{2})-(\d{4})$/);
  if (!match) {
    return { invalidFormat: true };
  }

  const isValidDate = (year: number, month: number, day: number): boolean => {
    const coordinationDay = day > 60 ? day - 60 : day;
    const currentDate = new Date();

    if (year < 100) {
      const currentYear = currentDate.getFullYear();
      const currentCentury = Math.floor(currentYear / 100) * 100;
      year += currentCentury;

      while (year > currentYear) {
        year -= 100;
      }
    }

    const birthday = new Date(year, month - 1, coordinationDay);

    return (
      Object.prototype.toString.call(birthday) === '[object Date]' &&
      !isNaN(birthday.getTime()) &&
      birthday.getFullYear() === year &&
      birthday.getMonth() === month - 1 &&
      birthday.getDate() === coordinationDay &&
      birthday <= currentDate
    );
  };

  const year = Number((match[1] || '') + match[2]);
  const month = Number(match[3]);
  const day = Number(match[4]);

  if (!isValidDate(year, month, day)) {
    return { invalidBirthday: true };
  }

  input = input.replace('-', '');
  if (input.length === 12) {
    input = input.substring(2);
  }

  const parity = input.length % 2;
  let sum = 0;

  for (let i = 0; i < input.length; i++) {
    let digit = parseInt(input.charAt(i), 10);

    if (i % 2 === parity) {
      digit *= 2;
    }

    if (digit > 9) {
      digit -= 9;
    }

    sum += digit;
  }

  if (sum % 10 !== 0) {
    return { invalidCheckDigit: true };
  }

  return null;
};